import enviro from 'enviro';
import { hubletApi } from 'hub-http/middlewares/core';
const knownQaDomainPieces = [/* eslint-disable-next-line hubspot-dev/prefer-hubspot-url-utils */
'local.hubspot.com', 'getsidekickqa', 'hubspotqa', 'hubspotfreeqa', 'hubspotemailqa', 'hubspotstarterqa', 'hubspotservicehubqa'];
const checkIsQa = hostname => knownQaDomainPieces.find(piece => hostname.includes(piece)) !== undefined;
export const determineHublet = (hostname = window.location.hostname) => {
  const hubletApiObject = hubletApi('api', 'hubspot', enviro.getHublet());
  if (checkIsQa(hostname)) {
    hubletApiObject.deployed.prod = hubletApiObject.deployed.qa;
  }
  return hubletApiObject;
};
export default determineHublet();